import { StyleSheet, Dimensions } from 'react-native'
import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

const { width } = Dimensions.get('window')

const styles = StyleSheet.create({
  screenWrapper: {
    flex: 1,
    position: 'relative',
    backgroundColor: Colors.white,
  },
  headerBackground: (top = 0) => {
    return {
      width: width,
      height: width / 2.9,
      paddingTop: top,
      backgroundColor: '#ED1B24',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
    }
  },
  container: {
    flex: 1,
  },
  headerWrapper: {
    height: 79,
    overflow: 'visible',
  },
  header: {
    height: 94,
    paddingBottom: 28,
    paddingHorizontal: 16,
    justifyContent: 'flex-end',
  },
  headerContentWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },
  empty: {
    width: 24,
    height: 24,
  },
  closeIcon: {
    tintColor: Colors.white,
  },
  scrollContainer: {
    borderRadius: 12,
    backgroundColor: Colors.white,
  },
  scrollContentContainer: (bottom = 0) => {
    return {
      flexGrow: 1,
      paddingBottom: bottom,
    }
  },
  titleContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
    paddingTop: 32,
  },
  title: {
    flexGrow: 1,
    flexShrink: 1,
  },
  infoIconContainer: {
    marginLeft: 16,
    flexShrink: 0,
  },
  infoIcon: {
    tintColor: Colors.vfRed,
  },
  desc: {
    marginHorizontal: 16,
  },
  sectionHeaderContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 32,
    marginHorizontal: 16,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: Colors.veryLightPinkTwo,
  },
  sectionHeaderDetails: {
    flexGrow: 1,
    flexShrink: 1,
    paddingLeft: 16,
  },
  inputContainer: {
    marginTop: 24,
    marginBottom: 16,
    marginHorizontal: 16,
    minHeight: 50,
  },
  inputText: {
    fontFamily: Fonts.type.VFFont,
  },
  mylocationContainer: {
    flexGrow: 1,
    minHeight: 232,
    margin: 16,
    marginBottom: 32,
    backgroundColor: 'white',
    elevation: 5,
    borderRadius: 7,
    shadowColor: Colors.black,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.16,
    shadowRadius: 8,
  },
  mapContainer: {
    position: 'relative',
    flexGrow: 1,
    minHeight: 186,
    borderTopLeftRadius: 7,
    borderTopRightRadius: 7,
    backgroundColor: Colors.white,
    overflow: 'hidden',
  },
  map: {
    ...StyleSheet.absoluteFillObject,
  },
  currentLocationButton: {
    padding: 16,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    maxHeight: 50,
  },
  currentLocationText: {
    paddingBottom: 3,
  },
  locationError: {
    marginHorizontal: 32,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  currentLocationErrorText: {
    flexGrow: 1,
    flexShrink: 1,
  },
  confirmButton: {
    margin: 16,
    marginBottom: 32,
  },

  // Modal
  modalHeader: (top = 24) => {
    return {
      marginTop: top + 8,
      marginHorizontal: 16,
      marginBottom: 32,
      alignItems: 'flex-end',
    }
  },
  modalContentContainerWraper: (bottom = 0) => {
    return {
      flexGrow: 1,
      paddingHorizontal: 16,
      paddingVertical: 32,
      paddingBottom: bottom,
    }
  },
  modalContentWraper: {
    flexGrow: 1,
    marginBottom: 32,
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
  verticalSpacing: {
    marginVertical: 16,
  },
  modalAnimIconContainer: {
    width: 120,
    height: 120,
    marginTop: 32,
  },
  modalAnimIcon: {
    flex: 1,
  },
  modalButton: {
    marginBottom: 16,
  },
  lastModalButton: {
    marginBottom: 32,
  },

  // Details
  detailsHeader: {
    marginTop: 24,
    marginHorizontal: 16,
    marginBottom: 32,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  modalContent: (bottom = 32) => {
    return {
      paddingBottom: Math.max(bottom, 32),
      marginHorizontal: 16,
    }
  },
  detailsItem: {
    flexDirection: 'row',
    marginVertical: 4,
  },
  itemDot: {
    paddingHorizontal: 16,
    lineHeight: 28,
  },
  item: {
    flexGrow: 1,
    flexShrink: 1,
  },
})

export default styles
